import React from 'react';
import texture from '../../../../images/homepage/section-texture.jpg';

interface IProps {
  imageUrl: string;
  children: React.ReactNode;
}

export default function HomepageMarketingCallout({ imageUrl, children }: IProps) {
  return (
    <div className="homepage-marketing-callout">
      <div className="homepage-marketing-callout__container">
        <div className="homepage-marketing-callout__image-container">
          <div
            className="homepage-marketing-callout__image"
            style={{ backgroundImage: `url("${imageUrl}")` }}
          />
        </div>
        <div
          className="homepage-marketing-callout__content"
          style={{ backgroundImage: `url("${texture}")` }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
